import { DUE_SOON_DAYS, REBILL_STALE_DAYS, TRACEABILITY_FROM, TRACEABLE_CATEGORIES, UNTRACEABLE_METHODS } from '@/function/expense/expense.tax.config';
import type { TypeExpenseQuery } from '@/types/expense/types.expense.query';

export const EXPENSE_CASH_PARAMS = {
    cashCategories: TRACEABLE_CATEGORIES.join(','),
    cashMethods: UNTRACEABLE_METHODS.join(','),
    cashFrom: TRACEABILITY_FROM,
};

export const expenseSummaryParams = (today: string) => ({ today, dueSoonDays: DUE_SOON_DAYS, ...EXPENSE_CASH_PARAMS });

export const expenseReviewParams = (today: string) => ({ today, rebillStaleDays: REBILL_STALE_DAYS, ...EXPENSE_CASH_PARAMS });

export function expenseQueryParams(query: TypeExpenseQuery): Record<string, string | number | boolean> {
    const params: Record<string, string | number | boolean> = { sort: query.sort, reverse: query.reverse, today: query.today };
    if (query.stage) params.stage = query.stage;
    if (query.search) params.search = query.search;
    if (query.state) params.state = query.state;
    if (query.category) params.category = query.category;
    if (query.rebill) params.rebill = query.rebill;
    if (query.customerId) params.customerId = query.customerId;
    if (query.from) params.from = query.from;
    if (query.to) params.to = query.to;
    if (query.facet) {
        params.facet = query.facet;
        if (query.facet === 'cash') Object.assign(params, EXPENSE_CASH_PARAMS);
    }
    return params;
}
